// Hodnocení výživy (1. 11. 2026, zadání Kristiny): otázky a popisky sdílené
// (pozn = klíč textové poznámky k výběru, dlouha = víceřádková; jenKdyz = otázka se ukáže jen při dané odpovědi)
// stránkou hovoru (sales) a sekcí Zpětná vazba výživa v kartě klientky.
// Klíče a hodnoty musí sedět s OTAZKY v netlify/functions/_lib/hodnoceniVyzivyDb.cjs.
import { apiFetch } from "./api.js";

export const ANO_CASTECNE_NE = [
  { key: "ano", label: "Ano" },
  { key: "castecne", label: "Částečně" },
  { key: "ne", label: "Ne" },
];

export const OTAZKY_VYZIVA = [
  { k: "hvezdy", cislo: 1, q: "Jak byste celkově ohodnotila konzultaci?", typ: "hvezdy" },
  { k: "pomohlo", cislo: 2, q: "Co vám z konzultace nejvíce pomohlo nebo utkvělo?", typ: "text" },
  { k: "informace", cislo: 3, q: "Bylo informací akorát?", typ: "vyber", pozn: "informace_pozn", dlouha: true, moznosti: [
    { key: "akorat", label: "Akorát" }, { key: "chybelo", label: "Něco chybělo" }, { key: "moc", label: "Moc" },
  ] },
  { k: "mp_zajem", cislo: 4, q: "Masterplan: Měla jste o něj zájem?", kratce: "Měla jste o něj zájem?", typ: "vyber", moznosti: [
    { key: "ano", label: "Ano" }, { key: "ne", label: "Ne" },
  ] },
  { k: "mp_dodrzuje", cislo: 4, q: "Masterplan: Daří se vám ho dodržovat?", kratce: "Daří se vám ho dodržovat?", typ: "vyber", pozn: "mp_dodrzuje_pozn", jenKdyz: { k: "mp_zajem", v: "ano" }, moznosti: ANO_CASTECNE_NE },
  { k: "jidelnicek", cislo: 5, q: "Využíváte svůj jídelníček?", typ: "vyber", pozn: "jidelnicek_pozn", moznosti: ANO_CASTECNE_NE },
  { k: "zmena", cislo: 6, q: "Cítíte nějakou změnu v jídle, energii nebo přístupu?", typ: "vyber", pozn: "zmena_pozn", dlouha: true, moznosti: [
    { key: "ano", label: "Ano" }, { key: "trochu", label: "Trochu" }, { key: "zatim_ne", label: "Zatím ne" },
  ] },
  { k: "priste", cislo: 7, q: "Co byste ocenila na další konzultaci?", typ: "text" },
];

export function popisOdpovedi(otazka, hodnota) {
  if (hodnota == null || hodnota === "") return "";
  if (otazka.typ === "vyber") return otazka.moznosti.find((m) => m.key === hodnota)?.label || String(hodnota);
  return String(hodnota);
}

const MESICE = ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"];
export function nazevMesice(m) {
  const [y, mm] = String(m || "").split("-").map(Number);
  if (!y || !mm) return "";
  const n = MESICE[mm - 1];
  return `${n.charAt(0).toUpperCase()}${n.slice(1)} ${y}`;
}
export function mesicKratce(m) {
  const mm = Number(String(m || "").split("-")[1]);
  return mm ? MESICE[mm - 1] : "";
}
/** "2026-10-14" -> "14. 10." (s rokem: "14. 10. 2026") */
export function datumKratce(iso, sRokem = false) {
  const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  return `${Number(m[3])}. ${Number(m[2])}.${sRokem ? ` ${m[1]}` : ""}`;
}
export function datumZCasu(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()}. ${d.getMonth() + 1}.`;
}
// 1. 11. 2026 (Láďa): ve scénáři hovoru domácí jméno („Miluška“), stejně jako v e-mailu.
const DOMACI = { "Miluše": "Miluška" };
export function domaciJmeno(jmeno) { const k = krestni(jmeno); return DOMACI[k] || k; }
export function krestni(jmeno) { return String(jmeno || "").trim().split(/\s+/)[0] || ""; }
export function inicialy(jmeno) {
  const c = String(jmeno || "").trim().split(/\s+/).filter(Boolean);
  return ((c[0]?.[0] || "") + (c.length > 1 ? c[c.length - 1][0] : "")).toUpperCase();
}

export async function hvGet(akce, params = {}) {
  const q = new URLSearchParams({ akce, ...params });
  const r = await apiFetch(`/api/hodnoceni-vyzivy?${q.toString()}`);
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}
export async function hvUloz(body) {
  const r = await apiFetch("/api/hodnoceni-vyzivy", { method: "POST", body: JSON.stringify({ akce: "uloz", ...body }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}

/** E-mail s odkazem na Google recenzi (jen uložené 4 a 5 hvězd, jednou). */
export async function hvGoogle(body) {
  const r = await apiFetch("/api/hodnoceni-vyzivy", { method: "POST", body: JSON.stringify({ akce: "google_odkaz", ...body }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}

/** Odznak u položky Hodnocení výživy v menu (Sidebar poslouchá tuhle událost). */
export function oznamPocet(n) {
  try { window.dispatchEvent(new CustomEvent("fw40-hodnoceni-vyzivy-pocet", { detail: Number(n) || 0 })); } catch { /* ignoruj */ }
}

export const GOOGLE_RECENZE_URL = "https://g.page/r/Cb-8FBqzApCZEAE/review";

/** Obecný POST na /api/hodnoceni-vyzivy (google_nahled, report). */
export async function hvPost(akce, body = {}) {
  const r = await apiFetch("/api/hodnoceni-vyzivy", { method: "POST", body: JSON.stringify({ akce, ...body }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}

/** Stavy hovoru a jejich popisky (pilulky v Hotovo, karta klientky). */
export const STAV_POPIS = {
  hotovo: "Dovoláno",
  zkusit_znovu: "Nedovoláno, 1. pokus",
  nedovolano: "Nedovoláno, uzavřeno",
  nechce: "Nechce hodnotit",
};

/** Datum a čas z ISO časové značky -> "2. 11. 2026". */
export function datumZCasuSRokem(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}
